// Relay capability negotiation keyed to the CURRENT connection (Codex S3): a stale answer
// from a superseded connection can never re-enable a control. The async fetch lives in
// app.svelte.ts (it needs the client); the generation bookkeeping lives here to be testable.
export class RelayCapabilitiesState {
  detachSubagent = $state(false);
  deviceSessions = $state(false);
  pairing = $state(false);
  externalAgents = $state(false);
  ready = $state(false);
  // The relay nudges an old desktop app instead of forwarding update_daemon to it.
  legacyDesktopUpdate = $state(false);
  generation = $state(0);

  beginRefresh(): number {
    return this.generation;
  }

  // Apply only if no newer connection superseded this fetch; report whether it stuck.
  applyIfCurrent(
    generation: number,
    detachSubagent: boolean,
    legacyDesktopUpdate = false,
    deviceSessions = false,
    pairing = false,
    externalAgents = false,
  ): boolean {
    if (this.generation !== generation) return false;
    this.pairing = pairing;
    this.externalAgents = externalAgents;
    this.detachSubagent = detachSubagent;
    this.legacyDesktopUpdate = legacyDesktopUpdate;
    this.deviceSessions = deviceSessions;
    this.ready = true;
    return true;
  }

  resetForConnection(): void {
    this.generation += 1;
    this.detachSubagent = false;
    this.deviceSessions = false;
    this.pairing = false;
    this.externalAgents = false;
    this.ready = false;
    this.legacyDesktopUpdate = false;
  }
}

export const relayCapabilities = new RelayCapabilitiesState();
